import type { TAnalyticsContext } from '@glomopay/analytics';
import { resolveTenantDomain } from '@glomopay/tenant';

import { AnalyticsEventName } from '../constants/analytics-event.constants';
import type { TAnalyticsEventCatalogue, TAnalyticsEventName, TApiResult } from '../types/analytics-events.types';
import { buildApiBackendProperties } from '../utils/build-api-backend-properties';

import { analyticsService } from './analytics-service';

const tenantDomain = resolveTenantDomain();

const track = <E extends TAnalyticsEventName>(eventName: E, properties: TAnalyticsEventCatalogue[E]) => {
  analyticsService.track(eventName, { ...properties, tenant_domain: tenantDomain });
};

export const analytics = {
  track,
  trackApiResult: (apiResult: TApiResult) => track(AnalyticsEventName.INVESTOR_API_BACKEND, buildApiBackendProperties(apiResult)),
  identify: (userId: string) => analyticsService.identify(userId),
  reset: () => analyticsService.reset(),
  setContext: (context: TAnalyticsContext) => analyticsService.setContext(context),
};
